import {
	getFromStorage,
	getQueryParam,
	removeFromStorage,
	saveToStorage,
} from 'common/utils/frontUtils';

const IDEV_ID_QUERY_PARAM = 'idev_id';
const AFFILIATE_LOCAL_STORAGE_KEY = 'affiliate';

export const getAffiliateId = (): string | null => {
	const affiliateIdQueryParam = getQueryParam(IDEV_ID_QUERY_PARAM);
	if (!!affiliateIdQueryParam) {
		var affiliateObject = {
			id: affiliateIdQueryParam,
			timestamp: new Date().getTime(),
		};
		saveToStorage('localStorage', AFFILIATE_LOCAL_STORAGE_KEY, JSON.stringify(affiliateObject));
		return affiliateIdQueryParam;
	}

	const affiliateLocalStorageString = getFromStorage('localStorage', AFFILIATE_LOCAL_STORAGE_KEY);
	const affiliateLocalStorageObj = !!affiliateLocalStorageString
		? JSON.parse(affiliateLocalStorageString)
		: null;
	const { id, timestamp } = (affiliateLocalStorageObj ?? {}) as { id?: string; timestamp?: number };
	if (!id || !timestamp) return null;

	const timeNow = new Date().getTime();
	const dayAsMilliseconds = 60 * 60 * 24 * 1000;
	const timeSinceAffiliateIdAddedInDays = (timeNow - timestamp) / dayAsMilliseconds;
	const AFFILIATE_ID_EXPIRES_IN_DAYS = 90;
	if (timeSinceAffiliateIdAddedInDays < AFFILIATE_ID_EXPIRES_IN_DAYS) {
		return id;
	} else {
		removeFromStorage('localStorage', AFFILIATE_LOCAL_STORAGE_KEY);
		return null;
	}
};
